import { authClient, API } from "../index";

// Count all modelos
export const countModelos = () => {
  return authClient().get(`${API}/modelo/count`);
};

// Get all modelos
export const getModelos = ({ page, limit, filters, searchTerm, marca }) => {
  const params = { page, limit };
  if (searchTerm !== undefined) params.searchTerm = searchTerm;
  if (marca !== undefined) params.marca = marca;
  if (filters) Object.assign(params, filters);
  return authClient().get(`${API}/modelo`, { params });
};

export const getModelosByIds = ({ list }) => {
  return authClient().get(`${API}/modelo`, {
    params: { list },
  });
};

// Get modelo by id
export const getModeloById = (id) => {
  return authClient().get(`${API}/modelo/${id}`);
};

// Update modelo
export const updateModelo = (id, modelo) => {
  return authClient().put(`${API}/modelo/${id}`, modelo);
};

// Create modelo
export const postModelo = (modelo) => {
  return authClient().post(`${API}/modelo`, modelo);
};

// Delete modelo
export const deleteModelo = (id) => {
  return authClient().delete(`${API}/modelo/${id}`);
};

// Change status modelo
export const changeStatusModelo = async (id, active) => {
  return authClient().put(`${API}/modelo/change-status/${id}`, { active });
};
